import api from '../../utils/services/api';
import { walletsActionLoading, walletsActionSuccess, walletsActionError } from '../ducks/wallets';

export const getWallets = () => {
  return async (dispatch) => {
    dispatch(walletsActionLoading);
    try {
      dispatch(walletsActionSuccess({
        data: [
          {
            ID: 0,
            NOME: 'Fulano',
            CPFCNPJ: '120.367.387-39',
            AGENCIA: '23646565',
            CONTA: '34560',
            DATAHORA: '02/02/2022 06:12:10',
            GERENTE: 'Gabriel',
            GESTOR: 'Lucas',
            EXECUTIVO: 'Maria',
            TIPOTAXA: 'Débito',
            VALORTAXA: ' R$ 30,00',
          },
          {
            ID: 1,
            NOME: 'Vitor',
            CPFCNPJ: '198.364.356-41',
            AGENCIA: '96968686',
            CONTA: '095435',
            DATAHORA: '03/05/2021 08:10:20',
            GERENTE: 'Caio',
            GESTOR: 'Pedro',
            EXECUTIVO: 'Alice',
            TIPOTAXA: 'Crédito',
            VALORTAXA: 'R$ 15,00',
          },
          {
            ID: 2,
            NOME: 'Igor',
            CPFCNPJ: '678.920.278-85',
            AGENCIA: '23646565',
            CONTA: '34560',
            DATAHORA: '05/02/2020 07:10:10',
            GERENTE: 'Milena',
            GESTOR: 'Laura',
            EXECUTIVO: 'Carlos',
            TIPOTAXA: 'Débito',
            VALORTAXA: 'R$ 20,00',
          },
        ],
        pagination: {
          nextPage: 1,
          page: 1,
          prevPage: 1,
          totalPages: 10,
          totalResult: 100,
        }
    }));
    }
    catch {
      dispatch(walletsActionError());
    }
  }
}